import React, { useState, useEffect } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import "./lightboxOverride.css";


const ProductGallery = ({ coverImage, images }) => {
  const allImages = [coverImage, ...images.map((img) => img.image)];
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false); // 👈 Lightbox için

  const handleThumbnailClick = (index) => {
    setSelectedIndex(index);
    setIsOpen(true); // 👈 tıklayınca lightbox aç
  };

  const handlePrev = () =>
    setSelectedIndex((prev) => (prev === 0 ? allImages.length - 1 : prev - 1));
  const handleNext = () =>
    setSelectedIndex((prev) => (prev === allImages.length - 1 ? 0 : prev + 1));

  // 👇 Lightbox zIndex ayarı
 useEffect(() => {
  const navbar = document.querySelector("#kisetsu-navbar");
  if (navbar) {
    if (isOpen) {
      navbar.style.display = "none";
    } else {
      navbar.style.display = "flex";
    }
  }
}, [isOpen]);



  return (
    <div>
      {/* Büyük görsel */}
      <div
        style={{
          width: "100%",
          height: "500px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f8f8f8",
          position: "relative",
          overflow: "hidden",
          marginBottom: "20px",
          borderRadius: "8px",
        }}
      >
        <img
          src={`https://ecommerce24.pythonanywhere.com${allImages[selectedIndex]}`}
          alt="Ürün görseli"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            cursor: "zoom-in",
          }}
          onClick={() => setIsOpen(true)} // 👈 büyüt
        />
        <button onClick={handlePrev} style={navBtnStyle("left")}>
          &lt;
        </button>
        <button onClick={handleNext} style={navBtnStyle("right")}>
          &gt;
        </button>
      </div>

      {/* Thumbnail'lar */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        {allImages.map((img, idx) => (
          <img
            key={idx}
            src={`https://ecommerce24.pythonanywhere.com${img}`}
            alt={`thumb-${idx}`}
            onClick={() => handleThumbnailClick(idx)}
            style={{
              width: "80px",
              height: "80px",
              objectFit: "cover",
              borderRadius: "6px",
              cursor: "pointer",
              border:
                idx === selectedIndex ? "2px solid #000" : "1px solid #ccc",
              opacity: idx === selectedIndex ? 1 : 0.6,
            }}
          />
        ))}
      </div>

      {/* 🔍 Lightbox */}
      {isOpen && (
        <Lightbox
          mainSrc={`https://ecommerce24.pythonanywhere.com${allImages[selectedIndex]}`}
          nextSrc={`https://ecommerce24.pythonanywhere.com${
            allImages[(selectedIndex + 1) % allImages.length]
          }`}
          prevSrc={`https://ecommerce24.pythonanywhere.com${
            allImages[
              (selectedIndex + allImages.length - 1) % allImages.length
            ]
          }`}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={handlePrev}
          onMoveNextRequest={handleNext}
          enableZoom={true}
        />
      )}
    </div>
  );
};

const navBtnStyle = (pos) => ({
  position: "absolute",
  top: "50%",
  [pos]: "10px",
  transform: "translateY(-50%)",
  background: "#fff",
  border: "1px solid #ccc",
  borderRadius: "50%",
  width: "35px",
  height: "35px",
  fontSize: "18px",
  cursor: "pointer",
  zIndex: 10,
  boxShadow: "0 1px 5px rgba(0,0,0,0.2)",
});

export default ProductGallery;
